module.exports = __webpack_public_path__ + "img/fancy_line_weight.10ec7fbb.svg";